module.exports = __webpack_public_path__ + "prod/1.42.2/img/new-mode-one.306b75b9.png";